import VueCookies from 'vue-cookies'

const PREFIX = "ZHBVUE_"; // 常量前缀
export const TOKEN = PREFIX + "TOKEN";
export const LOGIN_ACCOUNT = PREFIX + "LOGIN_ACCOUNT";
export const LOGIN_PWD = PREFIX + "LOGIN_PWD";
export const LOGIN_USER_INFO = PREFIX + "LOGIN_USER_INFO";
export const MENU_INFO = PREFIX + "MENU_INFO";
export const MENU_BTN_INFO = PREFIX + "MENU_BTN_INFO";
export const constants = {

    /**
     * 设置菜单信息
     * @param menuInfo
     */
    setMenuInfo: function (menuInfo) {
        if (!menuInfo) sessionStorage.removeItem(MENU_INFO);
        else sessionStorage.setItem(MENU_INFO, JSON.stringify(menuInfo));
    },

    /**
     * 设置菜单按钮信息
     * @param obj
     */
    setMenuBtnInfo: function (obj) {
        sessionStorage.setItem(MENU_BTN_INFO, JSON.stringify(obj));
    },
    getBtnShow(route, btnCodeArr) {
        let info = sessionStorage.getItem(MENU_BTN_INFO);
        let obj = info ? JSON.parse(info) : {};
        let arr = obj[route];
        if (arr && arr.length > 0) {
            for (let i = 0; i < btnCodeArr.length; i++) {
                if (arr.indexOf(btnCodeArr[i]) !== -1) return true;
            }
        }
        return false;
    },
    /**
     * 获取菜单信息
     * @returns {any}
     */
    getMenuInfo: function () {
        let info = sessionStorage.getItem(MENU_INFO);
        return info ? JSON.parse(info) : null;
    },
    /**
     * 设置登录用户信息
     * @param loginUserInfo
     */
    setLoginUserInfo: function (loginUserInfo) {
        sessionStorage.setItem(LOGIN_USER_INFO, JSON.stringify(loginUserInfo));
    },

    /**
     * 获取登录用户信息
     * @returns {string}
     */
    getLoginUserInfo: function () {
        let info = sessionStorage.getItem(LOGIN_USER_INFO);
        return info ? JSON.parse(info) : null;
    },

    /**
     * 删除登录用户信息
     */
    clearLoginUserInfo: function () {
        sessionStorage.removeItem(LOGIN_USER_INFO);
    },

    /**
     * 设置token
     * @param tokenStr
     */
    setToken: function (tokenStr) {
        sessionStorage.setItem(TOKEN, tokenStr);
    },

    /**
     * 获取token
     * @returns {string}
     */
    getToken: function () {
        return sessionStorage.getItem(TOKEN);
    },

    /**
     * 删除token
     */
    clearToken: function () {
        sessionStorage.removeItem(TOKEN);
    },

    /**
     * 记住账号密码
     */
    rememberLogin: function (loginAccount, loginPwd) {
        VueCookies.set(LOGIN_ACCOUNT, loginAccount);
        VueCookies.set(LOGIN_PWD, loginPwd);
    },

    /**
     * 获取登录账号
     * @returns {string}
     */
    getLoginAccount: function () {
        return VueCookies.get(LOGIN_ACCOUNT) || null
    },

    /**
     * 获取登录密码
     * @returns {string}
     */
    getLoginPwd: function () {
        return VueCookies.get(LOGIN_PWD) || null;
    }

};




// WEBPACK FOOTER //
// ./src/constants.js